import React, { useState } from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  onClick, 
  disabled = false,
  ...props 
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  const baseStyles = {
    borderRadius: '6px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontWeight: '400',
    transition: 'all 0.15s ease',
    opacity: disabled ? 0.6 : 1,
    fontFamily: 'Georgia, serif',
    transform: isPressed ? 'scale(0.98)' : 'scale(1)'
  };

  const getVariantStyles = () => {
    const variants = {
      primary: {
        backgroundColor: isHovered ? '#5A7A6A' : '#6B9080',
        color: 'white',
        border: 'none'
      },
      secondary: {
        backgroundColor: isHovered ? '#E5E7EB' : '#F3F4F6',
        color: '#1F2937',
        border: 'none'
      },
      outline: {
        backgroundColor: isHovered ? '#E8F4E8' : 'white',
        border: '1px solid #6B9080',
        color: '#6B9080'
      }
    };
    return variants[variant];
  };

  const sizes = {
    small: { padding: '8px 16px', fontSize: '14px' },
    medium: { padding: '12px 24px', fontSize: '16px' },
    large: { padding: '16px 32px', fontSize: '18px' }
  };

  return (
    <button
      style={{
        ...baseStyles,
        ...getVariantStyles(),
        ...sizes[size]
      }}
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false);
      }}
      onMouseDown={() => !disabled && setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;